import { render, staticRenderFns } from "./joined-segment.vue?vue&type=template&id=08b9bb0d"
import script from "./joined-segment.vue?vue&type=script&lang=js"
export * from "./joined-segment.vue?vue&type=script&lang=js"
import style0 from "./joined-segment.vue?vue&type=style&index=0&id=08b9bb0d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports